import router from '@/router/'
const identityCard = {
  state: {
    unitData:[],
    tokens:'',
    gameName:'',
    result:{}
  },
  getters: {
    
  },
  mutations: {
    AllData (state, data) {
      state.unitData = data
    },
    tokens (state, data) {
      state.tokens = data
    },
    getGameName(state, data)
    {
      state.gameName = data;
    },
    paragraphResultF(state,data)
    {
      state.result = data;
    }

  },
  actions: {
    getGameNames({commit}, data)
    {
      commit('getGameName', data);
    },
    unitAllData ({commit}, data) {
      commit('AllData', data);
    },
    paragraphResult({commit}, data)
    {
      commit('paragraphResultF', data);
    },
    tokenStr({commit}, data)
    {
      commit('tokens', data);
    },
    loginOut(){
      if(localStorage.printGameid)
      {
          let  gameid = localStorage.printGameid;
          let title = localStorage.printTi;
          
          localStorage.clear();
          localStorage.printGameid = gameid;
          localStorage.printTi = title;
          this.$router.push("/loginPrint");
      }else{
          localStorage.clear();
          this.$router.push("/gradeLogin");
      }
        
      location.reload();
    }
  }
}

export default identityCard



// WEBPACK FOOTER //
// ./src/store/modules/unitAllData.js